import { useContext, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
// import "react-multi-carousel/lib/styles.css";
import Notiflix from "notiflix";
import { Select, Space } from "antd";
import Form from "react-bootstrap/Form";
import { FaSearch } from "react-icons/fa";
import { IoFilter } from "react-icons/io5";
import { LuVegan } from "react-icons/lu";
import Carousel from "react-multi-carousel";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import "./Shop.css";
import { RiEBike2Line } from "react-icons/ri";
import { TbInfoSquare, TbPaperBag } from "react-icons/tb";
import PostApiCall from "../../helper/PostAPI.js";
import NewAddTocart from "../../../Buttons/NewAddTocart.js";
import ModifyQuantity from "../../../Buttons/ModifyQuantity.js";
import { newstore } from "./Store/newStore.js";
import GetSeoData from "../../../Helpers/GetSeoData.js";

export const ProductListing = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { cartItems, storeStatus, setLoginModalStatus, setModalSide } =
    useContext(newstore);

  const scrollRef = useRef(null);
  const [scroll, setScroll] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const pageLocation = useLocation();
  const [cuisines, setcuisines] = useState([]);
  const [allcuisines, setallcuisines] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [active, setActive] = useState("All");
  const [filterOffcanvas, setFilterOffcanvas] = useState(false);
  const [filterTypes, setfilterTypes] = useState([]);
  let count = 0;
  const [keyStrings, setKeyStrings] = useState([]);
  const [restaurantName, setRestaurantName] = useState(null);
  const [bannerDetails, setbannerDetails] = useState([]);

  const [allProductList, setAllProductList] = useState([]);
  const [productList, setProductList] = useState([]);

  const offerBanners = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    const handleScroll = () => {
      if (pageLocation.pathname === "/shop") {
        setScrolled(window.scrollY > 200);
      }
    };

    if (pageLocation.pathname === "/shop") {
      window.addEventListener("scroll", handleScroll);
    }

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pageLocation]);

  useEffect(() => {
    GetAllItems(params?.category);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [params?.category]);

  const GetAllItems = () => {
    Notiflix.Loading.Circle();

    PostApiCall.postRequest(
      {
        verticalroute: params.category,
        stateid: null,
      },
      "Get_All_Items"
    )
      .then((res) => res.json())
      .then((resData) => {
        if (resData?.data?.length > 0) {
          setProductList(resData.data);
          setAllProductList(resData.data);
        }
        Notiflix.Loading.Remove();
      });
  };

  const searchpProduct = (value) => {
    let searchedData = allProductList;
    if (value) {
      searchedData = searchedData?.filter((det) => {
        const valuesToSearch =
          det?.fld_variantname?.trim()?.toLowerCase() +
          det?.fld_categoryname?.trim()?.toLowerCase();
        return valuesToSearch?.includes(value?.trim()?.toLowerCase());
      });
    }
    setProductList(searchedData);
  };

  return (
    <div className="order-online-page overflow-hidden">
      <GetSeoData type="Vertical" route={params.category} />
      <section className="offer-banner mt-5">
        <Container fluid>
          {bannerDetails != "undefined" && bannerDetails?.length != 0 ? (
            <Carousel
              swipeable={true}
              draggable={true}
              showDots={true}
              responsive={offerBanners}>
              {bannerDetails?.length != 0 ? (
                bannerDetails
                  ?.filter((dat) => dat.fld_banner_status == "Yes")
                  .map((data) => {
                    return (
                      <div className="text-center mx-lg-1 mx-1">
                        <div className="offer-image-inner-banner">
                          <img alt={data.fld_alt} src={data.fld_banner_image} />
                        </div>
                      </div>
                    );
                  })
              ) : (
                <></>
              )}
            </Carousel>
          ) : (
            ""
          )}
        </Container>
      </section>
      {/* <QuickSelection /> */}
      <section
        className={scroll ? "sticky-search-bar shadow-sm mt-0 pb-1" : "mt-2"}>
        <Container
          fluid
          style={{
            marginTop: `${
              pageLocation.pathname === "/category/:category" && scrolled
                ? "0"
                : "130px"
            }`,
          }}>
          <Card className={scroll ? "" : "shadow-search"}>
            <Card.Body className="py-0 pe-0">
              <Row className="align-items-center w-100 me-1">
                <Col
                  lg={6}
                  className="pb-3 pt-lg-3 pe-0 d-flex justify-content-between align-content-center gap-2">
                  <div className="flex-div position-relative">
                    {/* <Form> */}
                    <Form.Control
                      type="text"
                      value={searchText}
                      onFocus={() => {
                        setcuisines(allcuisines);
                      }}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                        searchpProduct(e.target.value);
                      }}
                      placeholder="Search for a dish"
                    />

                    <FaSearch className="search-icon" />
                  </div>
                </Col>
                <Col lg={6} className="pe-0">
                  <Row className="food-type-filter-row">
                    <button
                      className={`item-category-filter all ${
                        active == "All" && "active"
                      }`}
                      // onClick={() => {
                      // 	setActive("All");
                      // 	setcuisines(allcuisines);
                      // 	setSearchText("");
                      // 	if (window.innerWidth < 568) {
                      // 		setFilterOffcanvas(true);
                      // 	}
                      // }}
                    >
                      {/* All Items */}
                      {/* <BsFilterSquareFill /> */}
                      {/* <IoFilter /> */}
                    </button>
                    {filterTypes?.map((data) => {
                      return (
                        <>
                          <button
                            key={data.fld_id}
                            type="button"
                            className={`item-category-filter veg ${
                              active == data.fld_filter_type ? "active" : ""
                            }`}
                            onClick={() => {
                              setActive(data.fld_filter_type);
                              const removeFav = allcuisines;
                              setcuisines(
                                removeFav.filter(
                                  (product) =>
                                    product.FLD_Food_Type ==
                                      data.fld_filter_type ||
                                    product.best_seller ==
                                      data.fld_filter_type ||
                                    product.contains_egg == data.fld_filter_type
                                )
                              );
                              setSearchText("");
                            }}>
                            <img
                              src={data.fld_image}
                              className="recipe-type-image"
                            />
                            {/* <GiPlainCircle /> */}
                            {data.fld_label}
                          </button>
                        </>
                      );
                    })}
                    <Space className="order-online-sort">
                      <Select
                        defaultValue="Sort by"
                        onChange={(value) => {
                          const sortedItems = [...productList];

                          if (value === "Price, High to Low") {
                            sortedItems.sort(
                              (a, b) =>
                                b.fld_website_discount_price -
                                a.fld_website_discount_price
                            );
                          } else if (value === "Price, Low to High") {
                            sortedItems.sort(
                              (a, b) =>
                                a.fld_website_discount_price -
                                b.fld_website_discount_price
                            );
                          }
                          setProductList(sortedItems);
                          // setcuisines(sortedItems);
                        }}
                        options={[
                          {
                            value: "Price, High to Low",
                            label: "Price, High to Low",
                          },
                          {
                            value: "Price, Low to High",
                            label: "Price, Low to High",
                          },
                        ]}
                      />
                    </Space>
                    <button
                      style={{ display: count > 0 ? "block" : "none" }}
                      className={`item-category-filter vegan ${
                        active == "Vegan" && "active"
                      }`}
                      onClick={() => {
                        setActive("Vegan");
                        const removeFav = allcuisines;
                        setcuisines(
                          removeFav.filter((product) => {
                            if (product.FLD_Food_Type === "Vegan") {
                              count++;
                              return product;
                            } else {
                              return false;
                            }
                          })
                        );
                        setSearchText("");
                      }}>
                      <LuVegan />
                      Vegan
                    </button>
                  </Row>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section className="mt-md-4 mb-4">
        <div className="sticky-top-category-heading d-flex justify-content-center align-items-center px-4">
          <h1>{allProductList[0]?.fld_categoryname}</h1>
        </div>
        <Container fluid={true}>
          <Row>
            {productList?.map((det, i) => {
              const isCart = cartItems.find((val) => {
                if (val.fld_variantid === det.fld_variantid) {
                  return det;
                }
                return false;
              });

              const shortDescriptions = det?.fld_short_description.slice(
                0,
                130
              );

              return (
                <Col md={6} xl={4} className="item-card-wrapper p-3" key={i}>
                  <div
                    className="item-card"
                    onClick={() => {
                      navigate(`/product/${det.fld_route}`);
                    }}>
                    <div className="recipe-img-wrapper recipe-img-wrapper-tab-view">
                      <Link to={"/shop"}>
                        <img
                          className="recipe-img order-lg-1 order-2"
                          src={det?.VariantImage}
                          alt={det?.fld_variantname}
                        />
                      </Link>
                    </div>
                    <div className="w-100 px-lg-3 ps-3 order-lg-2 order-1">
                      <p className="recipe-best mb-3">
                        <img
                          className="recipe-type"
                          src="https://globaltrendz.online/GrubDigestCDN/Images/veg_icon.png"
                        />
                        <span className="best-seller">Best Seller</span>
                      </p>
                      <h6>
                        <Link to={"/shop"}>{det?.fld_variantname}</Link>
                      </h6>
                      <p className="recipe-category">
                        <span>{det?.fld_categoryname}</span>
                      </p>
                      <p
                        className="recipe-description d-none d-lg-block"
                        dangerouslySetInnerHTML={{
                          __html:
                            det?.fld_short_description?.length > 130
                              ? shortDescriptions + "..."
                              : det?.fld_short_description || "",
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-2">
                    <div className="d-flex align-items-center gap-2">
                      <span>
                        <RiEBike2Line
                          className="wishlist-share"
                          title="Delivery"
                        />
                      </span>
                      <span>
                        <TbPaperBag
                          className="wishlist-share"
                          title="TakeAway"
                        />
                      </span>
                      <span>
                        <TbInfoSquare
                          className="wishlist-share cursor-pointer"
                          title="Read More"
                        />
                      </span>
                    </div>

                    <div className="d-flex gap-2 align-items-center">
                      <h6 className="recipe-price">
                        <span>Rs</span> {det?.fld_website_discount_price}
                      </h6>
                      {isCart ? (
                        <ModifyQuantity
                          itemid={det?.fld_variantid}
                          quantity={isCart.fld_quantity}
                          cartlineid={isCart.fld_cart_dtl_id}
                        />
                      ) : (
                        <span className="theme-btn cursor-pointer">
                          <NewAddTocart itemid={det?.fld_variantid} />
                        </span>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Container>
      </section>

      <section className="content-wrapper">
        <div className="container-fluid">
          <div className="row">
            {/* Bread */}
            {params?.category === "breads" && (
              <div className="content-wrapper-list">
                <h1>Order Bread Online in Chennai at the Best Price</h1>

                <p>
                  Start your day with wholesome bread delivered directly to your
                  home or business. At Ariha Foods, you can order bread online
                  at a very reasonable price with the convenience of same-day
                  bakery delivery. Our bakery specializes in crafting soft,
                  fresh, and nutritious breads that cater to modern lifestyles.
                  From daily essentials to specialty loaves, every product is
                  crafted with care, high-quality ingredients, and rigorous
                  hygiene standards to ensure maximum freshness and taste,
                  delivered promptly across Chennai.
                </p>
                <h2>Low GI Bread Manufacturer and Supplier in Chennai </h2>
                <p>
                  As a trusted low-GI bread manufacturer in Chennai, we
                  specialize in breads that maintain stable blood sugar levels
                  while offering great taste. Our low glycemic index breads are
                  perfect for health-conscious individuals, fitness enthusiasts,
                  and diabetics looking for nutritious alternatives. We combine
                  traditional baking techniques with modern technology to create
                  bread that supports a balanced diet without compromising
                  flavor. Order multigrain low GI bread from Ariha Foods and get
                  the healthy bakery item at a very reasonable price.
                </p>
                <h2>Multigrain Bread Supplier and Dealer in Chennai </h2>
                <p>
                  We are a leading multigrain bread dealer in Chennai, offering
                  breads packed with whole grains, seeds, and fiber. Our breads
                  are made using selected grains and natural ingredients to
                  provide maximum nutrition and flavor. Whether for daily
                  consumption at home or for retail and cafe businesses, our
                  breads are consistently fresh, soft, and wholesome. We also
                  offer delicious{" "}
                  <a href="https://arihafoods.com/category/brownies">
                    {" "}
                    brownies
                  </a>
                  ,
                  <a href="https://arihafoods.com/category/chocolate-confectionery">
                    {" "}
                    chocolate confectionery
                  </a>
                  ,
                  <a href="https://arihafoods.com/category/cookies">
                    {" "}
                    and cookies
                  </a>
                  .
                </p>
              </div>
            )}

            {/* Brownies */}
            {params?.category === "brownies" && (
              <div className="content-wrapper-list">
                <h1>Order Brownies Online in Chennai – Fresh & Delicious</h1>

                <p>
                  Indulge your sweet cravings with freshly baked brownies from
                  Ariha Foods. Now you can order brownies online and enjoy rich,
                  fudgy, and perfectly moist treats delivered straight to your
                  doorstep. Each brownie is baked using premium ingredients,
                  ensuring every bite is a delight. Perfect for gifting,
                  celebrations, or simply treating yourself, our brownies bring
                  joy to every occasion.
                </p>
                <h2>Buy Chocolate Brownies Cake Online in Chennai </h2>
                <p>
                  Craving a delicious treat? Now you can order chocolate brownie
                  in Chennai from Ariha Foods and enjoy bakery-fresh indulgence
                  at home. Our brownies are baked using premium cocoa, rich
                  chocolate, and carefully selected ingredients to deliver a
                  soft, fudgy texture and intense chocolate flavor in every
                  bite.
                </p>
                <p>
                  {" "}
                  Perfect for a quick snack, dessert, gifting, or special
                  occasions, our chocolate brownies are made to satisfy
                  chocolate lovers of all ages. With our easy online ordering
                  and fast delivery service, you can enjoy freshly baked
                  brownies wherever you are in Chennai – without compromising on
                  taste or quality.
                </p>
                <h2>Brownie Cake Shop in Chennai </h2>
                <p>
                  Looking for a brownie cake shop in Chennai? We offer a wide
                  range of brownie cakes that are perfect for birthdays,
                  anniversaries, corporate events, or any special occasion. Made
                  with high-quality ingredients and baked fresh, our brownie
                  cakes combine indulgence with convenience, creating memorable
                  moments with every slice. You can also choose from our wide
                  range of
                  <a href="https://arihafoods.com/category/breads"> breads</a>,
                  <a href="https://arihafoods.com/category/chocolate-confectionery">
                    {" "}
                    chocolate confectionery
                  </a>
                  ,{" "}
                  <a href="https://arihafoods.com/category/cookies">
                    {" "}
                    and cookies
                  </a>
                  .
                </p>

                <h2>Online Sizzling Brownie Delivery in Chennai</h2>
                <p>
                  Indulge in rich, decadent desserts with our premium brownie
                  range. At Ariha Foods, we offer online brownie at same day
                  delivery for those moments when you crave something truly
                  special. From classic favourites to indulgent desserts, you
                  can easily order sizzling brownie options and enjoy freshly
                  prepared treats delivered right to your doorstep.{" "}
                </p>
                <p>
                  {" "}
                  Our chocolate brownie cake is a perfect choice for
                  celebrations, birthdays, or dessert cravings, featuring a rich
                  chocolate base, soft texture, and deep cocoa flavour. Made
                  using quality ingredients and baked with care, each brownie
                  and brownie cake promises freshness, taste, and satisfaction
                  with convenient online ordering.
                </p>
              </div>
            )}

            {/* Chocolate Confectionery */}
            {params?.category === "chocolate-confectionery" && (
              <div className="content-wrapper-list">
                <h1>
                  Order Chocolate Confectionery Online – Freshly Baked & Ready
                  to Deliver
                </h1>

                <p>
                  Order chocolate confectionery online at Ariha Foods. We offer
                  a wide selection of chocolate-based desserts, including cups,
                  tarts, and specialty chocolate treats at best price. Designed
                  for convenience, our online ordering system allows you to
                  select, pay, and receive premium chocolate desserts with
                  reliable delivery and assured freshness. You can also choose
                  from our wide range of{" "}
                  <a href="https://arihafoods.com/category/breads"> breads</a>,
                  <a href="https://arihafoods.com/category/brownies">
                    {" "}
                    brownies
                  </a>
                  , and{" "}
                  <a href="https://arihafoods.com/category/cookies"> cookies</a>
                </p>
                <h2>Buy Chocolate Cupcakes Online </h2>
                <p>
                  Craving a quick chocolate fix? Buy chocolate cup cakes online
                  from us at the best price and enjoy freshly baked treats
                  delivered to your doorstep. Our chocolate cupcakes are soft,
                  moist, and made using premium cocoa, making them perfect for
                  instant dessert cravings, parties, and gifting. With easy
                  checkout and fast delivery, ordering your favourite cupcakes
                  online has never been easier.
                </p>
                <h2>Chocolate Tarts Online – Buy Fresh Desserts Anytime</h2>
                <p>
                  Looking to enjoy rich desserts at home? Chocolate tarts online
                  from Ariha Foods are available for quick purchase and
                  delivery. Featuring a crisp base and smooth chocolate filling,
                  our tarts are ideal for celebrations, special occasions, or
                  personal indulgence. Order online and enjoy bakery-fresh
                  chocolate tarts delivered on time.
                </p>
                <h2>
                  Buy Chocolate Pretzel Online – Order Now for Quick Delivery
                </h2>
                <p>
                  Enjoy the perfect blend of crunch and chocolate when you buy
                  chocolate pretzels online. Made with crispy pretzels
                  generously coated in rich, premium chocolate, our chocolate
                  pretzels are an ideal snack for chocolate lovers who enjoy a
                  sweet and salty twist. Each batch is prepared with quality
                  ingredients and hygienic processes to ensure great taste and
                  freshness.
                </p>
                <p>
                  {" "}
                  With easy online ordering, secure payments, and quick
                  delivery, you can order chocolate pretzels anytime for
                  personal treats, gifting, or party snacks. Whether you’re
                  craving something indulgent or looking for a unique chocolate
                  dessert, Ariha Foods makes it simple to order fresh chocolate
                  pretzels online and enjoy them without delay.
                </p>
              </div>
            )}
            {/* Cookie */}
            {params?.category === "cookies" && (
              <div className="content-wrapper-list">
                <h1>Order Cookies Online – Freshly Baked & Delivered</h1>

                <p>
                  Enjoy the convenience of freshly baked cookies delivered
                  straight to your doorstep. At Ariha Foods, you can order
                  cookies online and experience the perfect balance of taste,
                  texture, and freshness. Our cookies are prepared using
                  carefully selected ingredients and baked under strict hygiene
                  standards to ensure consistent quality. Whether for daily
                  snacking, office treats, or special occasions, our cookies
                  make every moment more enjoyable.
                </p>
                <h2>Chocolate Chip Cookies Online </h2>
                <p>
                  Our chocolate cookies are baked to perfection with generous
                  amounts of premium chocolate chips. Soft on the inside with a
                  light crunch on the outside, these cookies are perfect for
                  tea-time snacks, lunchbox treats, or dessert platters. Loved
                  by both kids and adults, they remain one of our most popular
                  cookie varieties.
                </p>
                <h2>Order Healthy Chocolate Protein Cookies Online</h2>
                <p>
                  For health-conscious customers, Ariha Foods offers chocolate
                  protein cookies online that combine taste with nutrition.
                  These cookies are designed to provide added protein while
                  retaining the indulgent chocolate flavour. They are an
                  excellent choice for fitness enthusiasts, busy professionals,
                  and anyone looking for smarter snack options.
                </p>
                <h2>Best Cookies Manufacturer and Supplier in Chennai</h2>
                <p>
                  As a reliable cookies supplier in Chennai, Ariha Foods caters
                  to retail stores, cafes, restaurants, corporate buyers, and
                  distributors. Our manufacturing process focuses on hygiene,
                  uniformity, and shelf stability, allowing us to meet both
                  retail and bulk requirements efficiently. We continually
                  refine our recipes to meet changing consumer preferences while
                  maintaining trusted quality. You can also choose from our wide
                  range of
                  <a href="https://arihafoods.com/category/breads"> breads</a>,
                  <a href="https://arihafoods.com/category/brownies">
                    {" "}
                    brownies
                  </a>
                  ,{" "}
                  <a href="https://arihafoods.com/category/chocolate-confectionery">
                    {" "}
                    and chocolate confectionery.
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
 
  
      <section className="fixed-bottom mb-0 ms-auto px-2">
        <div>
          <>
            <div className="d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center py-2">
              {cartItems?.length > 0 && (
                <Button
                  variant="danger"
                  size="lg"
                  className={
                    cartItems?.length > 0
                      ? "floating-button-cart floating-button-cart-btn d-flex"
                      : "floating-button-cart d-flex"
                  }
                  onClick={() => {
                    navigate("/cart");
                  }}>
                  <div>
                    <p className="mb-0 total-item-amount d-flex">
                      {cartItems?.length} Item
                      <span
                        style={{
                          display: cartItems?.length == 1 ? "none" : "block",
                        }}>
                        (s)
                      </span>
                      &nbsp; | ₹ {cartItems[0]?.fld_cart_amount_no_shipping}{" "}
                      Plus Taxes
                    </p>
                  </div>
                </Button>
              )}
            </div>
          </>
        </div>
      </section>
    </div>
  );
};
